import { FC } from 'react'
import { Col } from 'react-bootstrap'
import { Contract, ContractStatusMap } from '../../../models/contractsModel'
import { ContractsPath } from '../../../routes/path'
import { fmtDate } from '../../../util/date'
type ListItemProps = {
  contract: Contract
}

export const ListItemSection: FC<ListItemProps> = ({ contract }) => {
  return (
    <Col xs={12} sm={6} md={4}>
      <div className="card">
        <a href={`${ContractsPath}/${contract.id}`}>
          <div className="image">
            <img
              src={contract.product.imageUrl}
              alt="No Image"
              onError={(e: any) => {
                e.target.onError = null // 代替画像が取得できない場合の無限ループを回避
                e.target.src = '/images/no_image.png'
              }}
            />
          </div>
          <div className="info">
            <div className="title">{contract.product.title}</div>
            <div className="detail">{contract.store.name}</div>
            <div className="detail">
              {fmtDate(contract.transactionDate)}
              {contract.status == 'Active' ? (
                <span className="status active">{ContractStatusMap[contract.status]}</span>
              ) : (
                <></>
              )}
            </div>
          </div>
        </a>
      </div>
    </Col>
  )
}
